// console.log('index.js');

require('./index.scss');


require('./scripts/ag.ui.globalnotice.js');
require('./scripts/ag.ui.cookienotice.js');


// General global init
AG.ui.globalnotice.activateGlobalNotice();
AG.ui.cookienotice.activateCookieNotice();